var SHOP_ROOT = '/shop';
var SHOP_PREFIX = "".concat(SHOP_ROOT, "/");
var SEARCH_QUERY_PARAM = 'query';
export function buildShopHref(_a) {
    var _b = _a === void 0 ? {} : _a, topic = _b.topic, product = _b.product;
    if (topic && product)
        return "".concat(SHOP_ROOT, "/").concat(topic, "+").concat(product);
    if (topic)
        return "".concat(SHOP_ROOT, "/").concat(topic);
    if (product) {
        return "".concat(SHOP_ROOT, "?").concat(SEARCH_QUERY_PARAM, "=").concat(encodeURIComponent(product));
    }
    return "".concat(SHOP_ROOT, "/");
}
export function parseActiveSelection(location) {
    var _a;
    var url = URL.parse(location, 'http://n');
    var pathname = (_a = url === null || url === void 0 ? void 0 : url.pathname) !== null && _a !== void 0 ? _a : '';
    if (!pathname.startsWith(SHOP_PREFIX)) {
        return {
            topic: null,
            product: pathname === SHOP_ROOT
                ? (url === null || url === void 0 ? void 0 : url.searchParams.get(SEARCH_QUERY_PARAM)) || null
                : null,
        };
    }
    var _b = pathname
        .slice(SHOP_PREFIX.length)
        .split('/')[0]
        .split('+'), topic = _b[0], product = _b[1];
    return { topic: topic || null, product: product || null };
}
